import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../config/config';
@Injectable()
export class ReporteDocumentoService {
  dataDocumentoUrl = Config.URL_BASE + '/reporte/documento';
  urlBase = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }
  getInfoAgrupador(gral_emp_id: number): Observable<any> {
    const url_ = this.urlBase + '/cta/get/info_agrupador/' + gral_emp_id;
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepCueConXml(gral_emp_id: number,registros: number, rfc: String): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_cue_con/xml/' + gral_emp_id + '/' + registros + '/' + rfc;
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepPolPerXml(gral_emp_id: number,mes: number,anio: number, 
    tipoSolicitud: String,num: String,rfc: String ): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_pol_per/xml/'+gral_emp_id+'/'+mes+'/'+anio+'/'+tipoSolicitud+'/'+num+'/'+rfc;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepBalCompXml(gral_emp_id: number,tipoEnvio: String,mes: number,anio: number, 
    fecha: String,rfc: String): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_bal_comp/xml/'+gral_emp_id+'/'+tipoEnvio+'/'+mes+'/'+anio+'/'+fecha+'/'+rfc;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  getRepAuxFolXml(gral_emp_id: number,mes: number,anio: number, 
    tipoSolicitud: String,num: String,rfc: String): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_aux_fol/xml/'+gral_emp_id +'/'+mes+'/'+anio+'/'+tipoSolicitud+'/'+num+'/'+rfc;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRepAuxMovXml(gral_emp_id: number,mes: number,anio: number, 
    tipoSolicitud: String,num: String,rfc: String): Observable<any> {
    const url_ = this.dataDocumentoUrl
    + '/rep_aux_mov/xml/'+gral_emp_id +'/'+mes+'/'+anio+'/'+tipoSolicitud+'/'+num+'/'+rfc;
  //  url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}